import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { DialogTitle } from "@mui/material";
import { TenantForm } from "./useRegisterTenantButton";
import { contractTypeForView, useCategoryForView } from "../common/utils/Utils";
import { useTranslation } from "react-i18next";
import { getCompatibleCountry, getCompatibleState } from "./CompatibleCountry";
import { getAuthItems } from "../auth/AuthItems";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  formData: TenantForm;
  acceptButtonName: string;
  onRegister: () => void;
  onCancel: () => void;
}

/**
 * お客様テナントの情報確認ダイアログのコンポーネントです。
 */
export const ConfirmDialog = (props: ConfirmDialogProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Dialog open={props.open} onClose={() => props.onCancel()}>
      <div>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
          <div className="grid grid-cols-3 gap-x-2 gap-y-5">
            <label>{t("admin.companyName")}</label>
            <div className="col-span-2">{props.formData.companyName}</div>
            <label>{t("admin.useCategory")}</label>
            <div className="col-span-2">{useCategoryForView(props.formData.useCategory, t)}</div>
            <label>{t("admin.country")}</label>
            <div className="col-span-2">{`${getCompatibleCountry(t, props.formData.country)[0].label}`}</div>
            {getAuthItems().loginPole === "RUS" && ( // US(北米)極の場合のみ表示する
              <label>{t("admin.state")}</label>
            )}
            {getAuthItems().loginPole === "RUS" && ( // US(北米)極の場合のみ表示する
              <div className="col-span-2">{`${
                getCompatibleState(props.formData.country, props.formData.state)[0]?.label
              }`}</div>
            )}
            <label>{t("admin.givenName")}</label>
            <div className="col-span-2">{props.formData.givenName}</div>
            <label>{t("admin.familyName")}</label>
            <div className="col-span-2">{props.formData.familyName}</div>
            <label>{t("common.emailAddress")}</label>
            <div className="col-span-2">{props.formData.emailAddress}</div>
            <label>{t("admin.contractType")}</label>
            <div className="col-span-2">{contractTypeForView(props.formData.contractType, t)}</div>
          </div>
        </DialogContent>
        <DialogActions className="flex">
          <Button variant="contained" onClick={() => props.onRegister()}>
            {props.acceptButtonName}
          </Button>
          <Button variant="outlined" onClick={() => props.onCancel()}>
            {t("common.cancelButton")}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
